module.exports = __webpack_public_path__ + "static/fonts/BMKIRANGHAERANG-OTF.otf?a34a4cbc";